import classnames from "classnames";
import React, { useState } from "react";
import GenericModal from "web/react/components/generic-modal/generic-modal";
import PaywallMarkup from "web/react/components/paywall-markup/paywall-markup";
import SendToApp from "web/react/components/send-to-app/send-to-app";
import SendToAppWithTrackedLink from "web/react/components/send-to-app-with-tracked-link/send-to-app-with-tracked-link";
import { useSmallBreakpoint } from "web/react/hooks/use-breakpoint/use-breakpoint";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import styles from "./send-to-app-modal.css";

interface TrackedLinkProps {
    leadUrl: string;
    productId: string;
    reason: string;
}

interface SendToAppModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    url: string;
    analyticsEventLabel: string;
    paywalledClassName?: string | null;
    productImageURL?: string | null;
    appDeepLinkURL?: URL;
    trackedLink?: TrackedLinkProps;
    financialIncentiveWebviewToken?: string;
    downloadCTA?: string;
}

function SendToAppModal({
    isOpen,
    onClose,
    title,
    url,
    analyticsEventLabel,
    paywalledClassName,
    productImageURL,
    appDeepLinkURL,
    trackedLink,
    financialIncentiveWebviewToken,
    downloadCTA,
}: SendToAppModalProps): JSX.Element {
    let smallScreen = !useSmallBreakpoint();
    let bottomModal = environment.getFeature("mg_ios_modal_bottom") && smallScreen;
    let [closed, setClosed] = useState(true);
    // "Download the Lyst App for free"
    downloadCTA = downloadCTA ? downloadCTA : gettext("feed.show_more.app_overlay.cta");
    function handleOpen(): void {
        setClosed(false);
    }
    function onModalClose(): void {
        setClosed(true);
        analytics.event("app_overlay", "modal_dismissed", analyticsEventLabel);
        onClose();
    }

    return (
        <>
            <GenericModal
                isOpen={isOpen}
                onAfterOpen={handleOpen}
                onClose={onModalClose}
                className={classnames({
                    [styles.modal]: bottomModal,
                    [styles.closed]: closed && bottomModal,
                })}
            >
                {!trackedLink ? (
                    <SendToApp
                        analyticsEventLabel={analyticsEventLabel}
                        title={title}
                        url={url}
                        productImageURL={productImageURL}
                        downloadCTA={downloadCTA}
                    />
                ) : (
                    <SendToAppWithTrackedLink
                        analyticsEventLabel={analyticsEventLabel}
                        title={title}
                        url={url}
                        productImageURL={productImageURL}
                        downloadCTA={downloadCTA}
                        className={styles.withTrackedLinkContainer}
                        appDeepLinkURL={appDeepLinkURL}
                        financialIncentiveWebviewToken={financialIncentiveWebviewToken}
                        {...trackedLink}
                    />
                )}
            </GenericModal>
            {paywalledClassName && <PaywallMarkup cssSelector={paywalledClassName} />}
        </>
    );
}

export default SendToAppModal;
